import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import Angie from "../WhiteHouseAssets/Avatars/Angie-Profile.webp";
import Patrick from "../WhiteHouseAssets/Avatars/Patrick-Profile.webp";
import Liz from "../WhiteHouseAssets/Avatars/Liz-Profile.webp";
import Mom from "../WhiteHouseAssets/Avatars/Mom-Profile.webp";

import Gunpic from "./WhiteHousePictures/GunPic.webp";
import santacam from "./WhiteHousePictures/SantaCam.webp";

export const WhiteHouseMessageContent: Chat_content[] = [
  {
    icon: Angie,
    name: "Angie",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "I know who leaked the affair story to the press",
        },
        timestamp: "2022-12-07T16:44:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Who?",
        },
        timestamp: "2022-12-07T16:45:00.000Z",
        from: "Angie",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Consuelo, the cleaner",
        },
        timestamp: "2022-12-07T16:45:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Do you have any evidence?",
        },
        timestamp: "2022-12-07T16:46:00.000Z",
        from: "Angie",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I never told you but back in October she confronted me about finding your panties in my desk drawer",
        },
        timestamp: "2022-12-07T16:46:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "You should have told me sooner. But anyway.",
        },
        timestamp: "2022-12-07T16:48:00.000Z",
        from: "Angie",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Well anyway I didn’t want to sack her because she’s always been close with Elizabeth and I was worried she’d spill it. I gave her $500 as hush money. A week ago I started getting the spooks because she was always avoiding direct eye contact with me, like she was ashamed of something. So I put a few special service guys to the task of keeping a close eye on her. Presidential privilege of course. The tech specialists just told me she deposited a payment of $10,000 into her bank on the day the story broke. Are you gonna tell me that’s a coincidence?!",
        },
        timestamp: "2022-12-07T16:49:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "All checks out- I can't believe that tell-tale snake!",
        },
        timestamp: "2022-12-07T16:53:00.000Z",
        from: "Angie",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "You have to confront her.",
        },
        timestamp: "2022-12-07T16:54:00.000Z",
        from: "Angie",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Just checked the cleaning schedule and she’s working today. I’m going to see her after my 5pm meeting. She won’t know what’s coming for her.",
        },
        timestamp: "2022-12-07T16:55:00.000Z",
        from: "George",
        status: "Read",
      },
    ],
  },
  {
    icon: Patrick,
    name: "Patrick",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "You shouldn't have",
        },
        timestamp: "2022-12-07T16:27:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: {
            image: Gunpic,
            date: "7 Dec 2022",
            time: " 4:27 PM",
            location: "",
          },
        },
        timestamp: "2022-12-07T16:27:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "You’re welcome, George. I know these are tough times for you and I wanted to show you I’ve got your back. I’m home already but I’ll see you tomorrow.",
        },
        timestamp: "2022-12-07T16:33:00.000Z",
        from: "Patrick",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Thanks. I’ll be taking it to Camp David over the holidays. See you tomorrow",
        },
        timestamp: "2022-12-07T16:27:00.000Z",
        from: "George",
        status: "Read",
      },
    ],
  },
  {
    icon: Liz,
    name: "Liz",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Hi love, fred and minnie desperate for one of these new santa cam baubles. Think they’ve seen them on tv. It’s basically an xmas ornament with a live webcam that they think will prove santa exists 😂 will you order one on your nozama account please?",
        },
        timestamp: "2022-11-17T12:49:00.000Z",
        from: "Liz",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "here’s the link: www.nozama.com /santacam183f9041a",
        },
        timestamp: "2022-11-17T12:49:00.000Z",
        from: "Liz",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: {
            image: santacam,
            date: "17 Nov 2022",
            time: " 12:49 PM",
            location: "",
          },
        },
        timestamp: "2022-11-17T12:49:00.000Z",
        from: "Liz",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Just been ordered",
        },
        timestamp: "2022-11-17T12:54:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Thanks",
        },
        timestamp: "2022-11-17T12:56:00.000Z",
        from: "Liz",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I have set up the Santa Cam. Entry passcode is Buster’s birthday.",
        },
        timestamp: "2022-11-19T19:14:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Thanks",
        },
        timestamp: "2022-11-19T19:16:00.000Z",
        from: "Liz",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Hi George, I’ve been thinking a lot since our lunch today. I just want to let you know that I appreciate your efforts to reconcile with me. I hope for the both of us that we will come out of this stronger, but please understand that it will take me time to forgive you. See you on the weekend.",
        },
        timestamp: "2022-12-07T18:49:00.000Z",
        from: "Liz",
        status: "Unread",
      },
    ],
  },
  {
    icon: Mom,
    name: "Mom",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "Happy birthday, mom. Are you with Alvin?",
        },
        timestamp: "2022-10-30T08:45:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Thanks darling. Yes I am with him now.",
        },
        timestamp: "2022-10-30T08:48:00.000Z",
        from: "Mom",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Good. See you on the weekend.",
        },
        timestamp: "2022-10-30T08:49:00.000Z",
        from: "George",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Home now. See you then.",
        },
        timestamp: "2022-10-30T12:48:00.000Z",
        from: "Mom",
        status: "Read",
      },
    ],
  },
];
